<div *ngIf="showNotification"  class="overlay-enabled"></div>
<div class="header-container displayNone">
  <div class="logo-container">
    <a class="sidebar-toggle" id="mobile-toggler" matRipple [matRippleUnbounded]="true" [matRippleCentered]="true"
      (click)="toggleSidebar()" [ngStyle]="{'color':systemConfigColor}">
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a>
  </div>
</div>

<div class="header-container header-with-nb-icon">
  <nb-actions size="small">
    <nb-action *ngIf="this.activCallData" class="control-item p-0 header-activeCall" [ngStyle]="{'background':systemShadow}" >
      <span class="text-part">{{ getPhoneNumber(this?.activCallData?.phoneNumber) }}</span>
      <span>{{ getActiveTime(this?.activCallData?.timeOfCall) }}</span>
      <span class="plus-icon" (click)="openCallDetailModal(this.activCallData)">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9.74427" cy="9.74427" r="9.74427" fill="aliceblue" [ngStyle]="{'fill':systemConfigColor}" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.99926 5C9.56822 5 9.21879 5.34943 9.21879 5.78047V9.2196H5.78047C5.34943 9.2196 5 9.56902 5 10.0001C5 10.4311 5.34943 10.7805 5.78047 10.7805H9.21879V14.2195C9.21879 14.6506 9.56822 15 9.99926 15C10.4303 15 10.7797 14.6506 10.7797 14.2195V10.7805H14.2195C14.6506 10.7805 15 10.4311 15 10.0001C15 9.56902 14.6506 9.2196 14.2195 9.2196H10.7797V5.78047C10.7797 5.34943 10.4303 5 9.99926 5Z" fill="#fff" />
      </svg>
      </span>
  </nb-action>

    <nb-action href="mailto:" class="control-item notification_dropdown" icon="email-outline" matRipple
      [matRippleUnbounded]="true" [matRippleCentered]="true"></nb-action>

    <nb-action class="control-item notification_dropdown " id="ReadNotification" [ngClass]="{'show-dot' : notificationBadgeText !== ''}"
      icon="bell-outline" matRipple (click)="readNotifications($event)" [badgeText]=notificationBadgeText
      badgePosition="top right" badgeStatus="danger">
    </nb-action>

    <!-- Phone Dialer -->

    <nb-action class="control-item notification_dropdown" icon="phone-outline" href="tel:" nbPopoverTrigger="click"
      popoverTitle="dial" id="phoneDialer" nbPopoverPlacement="bottom" matRipple></nb-action>

    <nb-action class="user-action" *nbIsGranted="['view', 'user']" matRipple [matRippleUnbounded]="true"
      [matRippleCentered]="true">
      <nb-user [nbPopover]="userProfileCard" (click)="showUserCard=true" nbPopoverTrigger="click"
        popoverTitle="userProfile" nbPopoverClass="userProfileClass" nbPopoverPlacement="bottom" matRipple
        [onlyPicture]="userPictureOnly" [name]="username" >
      </nb-user>
    </nb-action>
  </nb-actions>
  <!-- User Profile Card -->
  <ng-template #userProfileCard class="userDetails">
    <div class="userCard" *ngIf="showUserCard">
      <div class="cardHeader d-flex">
        <div class="userProfile">
          <img src="{{user?.picture}}" class="rounded-pill" alt="" height="60px" width="60px">
        </div>
        <div class="userNameContainer overflow-hidden">
          <span class="userName font-weight-bolder">Welcome {{firstName |titlecase}}</span>
          <span class="userEmail text-muted">
            {{userEmail}}
          </span>
        </div>
        <span class="material-icons pull-right cursor-pointer" style="font-size: 19px; color: darkgray;"
          (click)="showUserCard=false"> close </span>
      </div>
      <hr style="margin: -7px 25px 9px 25px;">
      <div class="cardBody">
        <ul class="userMenu w-100" style="height: 375px;overflow-y: auto;">
          <li *ngFor="let user of userProfileMenu" (click)="profileMenuClick(user.title)">{{user.title}}</li>
          <hr style="margin: 10px 25px;">
          <li (click)="help()">Help</li>
          <hr style="margin: 10px 25px;">
          <li (click)="logOut()">Log Out </li>
        </ul>
      </div>
    </div>
  </ng-template>

  <div id="rem-not" [ngStyle]="{'right': checkReminderRecord ? '78vh' : '25px'}" [ngClass]="{'custom-top': checkReminderRecord}"
  *ngIf="showNotification"
    class="dropdown-menu notifi-drp-dwn">
    <ngx-reminder-notification [reminderList]="reminderList" (ShowHideModel)="ShowHideModel($event)" [checkReminderRecord]="checkReminderRecord" (closeReminder)="closeReminder($event)" [notificationList]="notificationList"
      [unreadReminderCount]="unreadReminderCount" [unreadNotificationCount]="unreadNotificationCount"
      (emitToOpen)="redirect($event)" (emitToEdit)="openReminderModal($event)"
      (emitToLoadNotification)="onScrollNotification($event)" (emitToLoadReminder)="onScrollReminder($event)"
      [loader]="loader" [getTablesForMenuData]="getTablesForMenuData" (emitToRead)="updateMessageStatus($event)" (emitDeleted)="deletedMessage($event)"
      (emitReminderRead)="reminderCompleted($event)">
    </ngx-reminder-notification>
  </div>

</div>
